module.exports = __webpack_public_path__ + "media/images/bottom_ad-c70b68e611b9291e90361519867a4344.png";